import { render, staticRenderFns } from "./ExportCard.vue?vue&type=template&id=dd0495cc&scoped=true&"
import script from "./ExportCard.vue?vue&type=script&lang=js&"
export * from "./ExportCard.vue?vue&type=script&lang=js&"
import style0 from "./ExportCard.vue?vue&type=style&index=0&id=dd0495cc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd0495cc",
  null
  
)

export default component.exports